import { fg } from '@confluence/feature-gating';

// todo: remove this workaround and use directly within components.
// eslint-disable-next-line confluence-feature-gating/inline-usage
export const useIsBlogTreeUnderContentTreeFFEnabled = () => fg('blog_tree_under_content_tree');
